import { Company } from "../../../../interface/company";
import { SideMenu, SideMenuChild } from "../../../../interface/side-menu";
import { roles } from "../../../../shared/lists/roles";
import { osPanelTarget } from "../../../page/company/os/panel/os-panel-target";

/**
 * Com `useNewOsPanel` ligado os itens abrem o painel novo já no chip da listagem (`?chip=`), como em
 * `mekanic-menu.ts`. Sem a flag devolve `{}` e o item segue na rota legada.
 */
function _panelTarget(company: Company, scope: 'os' | 'budget', chip: string): Pick<SideMenuChild, 'href' | 'queryParams'> {
  return osPanelTarget(company, scope, chip) ?? {};
}

export const TCAR_INTEGRATED_MENU: (company: Company) => SideMenu[] = (company) => {

  const menus: SideMenu[] = [
    // company
    {
      component: 'company',
      href: ['/company'],
      icon: 'domain',
      isTopLevel: true,
    },
    {
      component: 'budgets',
      profileModule: "OS",
      blockedRoles: [roles.mechanic.id],
      icon: 'assignment',
      isTopLevel: true,
      // 'budget-panel' (layout do painel com mais de um chip) mantém o grupo destacado.
      shadows: ['budget-create', ...(company.useNewOsPanel ? ['budget-panel'] : [])],
      children: [
        {
          component: 'budget',
          shadows: ['budget_detail', 'ro_create'],
          profileRule: "OS.list.budget",
          href: ['company', company.id, 'os', 'budget'],
          ..._panelTarget(company, 'budget', 'aberto'),
        },
        {
          component: 'rejected',
          shadows: ['rejected_detail'],
          profileRule: "OS.list.rejectedBudget",
          href: ['company', company.id, 'os', 'rejected'],
          ..._panelTarget(company, 'budget', 'rejeitado'),
        },
      ]
    },
    {
      component: 'ro',
      blockedRoles: [roles.mechanic.id],
      profileModule: "OS",
      icon: 'assignment_turned_in',
      isTopLevel: true,
      // 'os-panel' (layout do painel com mais de um chip, ou só "Rejeitadas") mantém o grupo destacado.
      shadows: ['ro-create', ...(company.useNewOsPanel ? ['os-panel'] : [])],
      children: [
        {
          component: 'integrated_opened',
          // No painel, os chips Abertas/Fechadas têm `menuComponent` 'opened'/'closed'; este item cobre os dois.
          shadows: ['opened_detail', ...(company.useNewOsPanel ? ['opened', 'closed'] : [])],
          profileRule: "OS.list.integratedOpen",
          href: ['company', company.id, 'os', 'integrated_opened'],
          ..._panelTarget(company, 'os', 'aberta'),
        },
        {
          profileModule: "OS",     // finalizadas
          component: 'finished',
          // O chip Faturadas do painel tem `menuComponent` 'ended'.
          shadows: ['ended_detail', ...(company.useNewOsPanel ? ['ended'] : [])],
          profileRule: "OS.list.endedRo",
          href: ['company', company.id, 'os', 'ended'],
          ..._panelTarget(company, 'os', 'faturada'),
        },

      ]
    },
    {
      component: 'clients',
      profileModule: "CLIENT",
      blockedRoles: [roles.mechanic.id],
      isTopLevel: true,
      icon: 'assignment_ind',
      href: ['company', company.id, 'clients'],
      shadows: ['client-detail']
    },
    {
      component: 'users',
      profileModule: "USER",
      blockedRoles: [roles.mechanic.id, roles.consultant.id],
      isTopLevel: true,
      icon: 'people',
      children: [
        {
          profileRule: "USER.REGISTERED_USERS.read",
          component: 'user-list',
          href: ['company', company.id, 'users'],
          shadows: ['user-detail'],
        },
        {
          profileRule: "USER.ACCESS_CONTROL.read",
          component: 'access-profile',
          href: ['company', company.id, 'access-profile'],
          shadows: ['access-profile-edit']
        }
      ]
    },
    {
      component: 'records',
      blockedRoles: [roles.mechanic.id, roles.consultant.id],
      isTopLevel: true,
      profileModule: "RECORDS",
      icon: 'note_add',
      children: [
        {
          component: 'checklist',
          profileRule: "RECORDS.mkgChecklist.read",
          href: ['company', company.id, 'records', 'checklist']
        },
        {
          component: 'checklist-models',
          profileRule: "RECORDS.checklistByModel.read",
          href: ['company', company.id, 'records', 'checklist-model']
        },
        {
          component: 'ro-types',
          profileRule: "RECORDS.OStypes.read",
          href: ['company', company.id, 'records', 'ro-types']
        },
      ]
    }
  ];
  return menus
}
